import '.jo{display:inline-block;}.ssr-plugin'
import '.jp{margin-top:1.5rem;}.ssr-plugin'
import '.ay{font-size:0.875rem;}.ssr-plugin'
import '.jq{color:var(--palette-blue-500);}.ssr-plugin'
import '.hc{text-decoration:underline;}.ssr-plugin'
import { useEffect, useState } from 'react'
import { styled } from 'inlines'

export type DiscoveryCrawlerPaginationFooterProps = {
  nextPageHref: string | null
}

export const DiscoveryCrawlerPaginationFooter = ({
  nextPageHref,
}: DiscoveryCrawlerPaginationFooterProps) => {
  const [mounted, setMounted] = useState(false)

  useEffect(() => {
    setMounted(true)
  }, [])

  if (!nextPageHref || mounted) {
    return null
  }

  return (
    <a className="jo jp ay jq hc"
      rel="next"
      href={nextPageHref}
    >
      next page
    </a>
  )
}
